/**
 * Functionality
 */

import detectTabbing from './lib/detect-tabbing'
detectTabbing()

import externalLinks from './lib/external-links'
externalLinks()

import subLinks from './lib/sub-links'
subLinks()

import smoothAnchors from './lib/smooth-anchors'
smoothAnchors()

import vhCheck from 'vh-check'
vhCheck()

/**
 * App
 */

import './app.js'

/**
 * Components
 */

import './components/UseColor'
import './components/CornerShape'
import './components/Slider'
import './components/Ultralazy'
import './components/PageFilter'
import './components/PageToggle'
import './components/Navigation'
import './components/Balancer'
import './components/UseTypography.js'
import './components/Mailchimp'
import './components/CookieBanner'
import './components/VideoSwitcher'
import './components/Monogrid'
import './components/map/Map'
import './components/map/ActiveMapHover'
import './components/map/ActiveMapClick'
import './components/map/ActiveMapScroll'
// import './components/map/ContentSyncComponent'
